import { gql } from '@apollo/client';

//returns a personIncidentSpecific
export const PERSON_DRUG_HISTORY = gql`
  query personDrugHistory($personId: ID!, $originatorId: ID!){
    personDrugHistory(personId: $personId, originatorId: $originatorId) {
      id
      incident {
        id
        address {
          id
          name
        }
        classification {
          id
          name
        }
        callTime
        incidentNumber
        officerIncidentSpecifics {
          id
          officer {
            id
            deptAttribute {
              id
              badge
              ori {
                id
                oriName
                abbreviation
              }
            }
          }
        }
      }
      incidentInvolvement {
        id
        name
      }
      drugTypes {
        id
        name
      }
    }
  }
`;